<script>
    import { _ } from "svelte-i18n";    
</script>
<div class="m-0 p-0">
    <p class="text-base mb-4">
      <strong>{$_('docs.license.intro.plugin')}</strong> {$_('docs.license.intro.text')} 
      <strong>{$_('docs.license.intro.company')}</strong>. {$_('docs.license.intro.copyright')}
    </p>
  
    <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.license.usage.title')}</h3>
    <p class="text-base mb-4">
      <strong>{$_('docs.license.usage.company')}</strong> {$_('docs.license.usage.text')} 
      <strong>{$_('docs.license.usage.plugin')}</strong> {$_('docs.license.usage.terms')}
    </p>
  
    <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.license.restrictions.title')}</h3>
    <ul class="list-disc list-inside mb-4">
      <li>
        {$_('docs.license.restrictions.restriction_1.before_bold')} 
        <strong>{$_('docs.license.restrictions.restriction_1.plugin')}</strong> 
        {$_('docs.license.restrictions.restriction_1.after_plugin')} 
        <strong>{$_('docs.license.restrictions.restriction_1.company')}</strong>
        {$_('docs.license.restrictions.restriction_1.after_company')}
      </li>
      <li>
        {$_('docs.license.restrictions.restriction_2.before_bold')} 
        <strong>{$_('docs.license.restrictions.restriction_2.plugin')}</strong> 
        {$_('docs.license.restrictions.restriction_2.after_plugin')}
      </li>
      <li>
        {$_('docs.license.restrictions.restriction_3.before_bold')} 
        <strong>{$_('docs.license.restrictions.restriction_3.plugin')}</strong>
        {$_('docs.license.restrictions.restriction_3.after_plugin')}
      </li>
    </ul>
  
    <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.license.warranty.title')}</h3>
    <p class="text-base mb-4">
      <strong>{$_('docs.license.warranty.plugin')}</strong> {$_('docs.license.warranty.text')} 
      <strong>{$_('docs.license.warranty.company')}</strong> {$_('docs.license.warranty.disclaimer')}
    </p>
  
    <h3 class="text-xl font-medium mt-4 mb-2">{$_('docs.license.contact.title')}</h3>
    <p class="text-base mb-4">
      {$_('docs.license.contact.text')} 
      <strong>{$_('docs.license.contact.company')}</strong> {$_('docs.license.contact.email_intro')} 
      <a href="mailto:tal@datalogics.co.il" class="text-blue-600 hover:underline">tal@datalogics.co.il</a>.
    </p>
</div>